import { Body as ListBody, ListWrapper } from 'ui/listLegacy/styled';
import { ListHeader, useListContext } from 'ui/listLegacy';
import { FieldsListFooter } from './FieldsListFooter';
import { FieldsListRow } from './FieldsListRow';

export const testIds = {
  list: 'segmentation-export-to-csv-list',
};

export const FieldsList = ({
  selectedFields,
  setSelectedFields,
}: {
  selectedFields: string[];
  setSelectedFields: (newSelected: string[]) => void;
}) => {
  const { filteredItems } = useListContext();

  return (
    <ListWrapper role="list" aria-label="segmentation-export-to-csv-list">
      <ListHeader />
      <ListBody data-test={testIds.list}>
        {filteredItems.map((item) => {
          const { id, name } = item;
          const isSelected = selectedFields.includes(id);
          const setChecked = () => {
            const newSelected = [...selectedFields];
            if (isSelected) {
              const index = newSelected.indexOf(id);
              newSelected.splice(index, 1);
              setSelectedFields(newSelected);
            } else {
              setSelectedFields([...newSelected, id]);
            }
          };
          return (
            <FieldsListRow
              key={id}
              id={id}
              name={name}
              status={selectedFields.includes(item.id)}
              setChecked={setChecked}
            />
          );
        })}
      </ListBody>
      <FieldsListFooter
        selectedCount={selectedFields.length}
        setSelectedFields={setSelectedFields}
      />
    </ListWrapper>
  );
};
